var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('portal',{staticClass:"gallery-dashboard-portal v-application",attrs:{"selector":"#recent-gallery-posts"}},[_c('div',{staticClass:"v-application",staticStyle:{"display":"block"}},[(_vm.renderGallerDashboard)?_c('GalleryDashboardSection'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }